<lms-breadcrumb
  [crumbs]="[{ label: 'roleplay.subscriptions', icon: 'glicon-itinerary', route: '/roleplay-subscriptions' }]"
></lms-breadcrumb>
<rl-subscription-list (save)="saveSubscription($event['detail'])"></rl-subscription-list>
